// extracted by mini-css-extract-plugin
export default {"responsive-success-payment":"d1yQmN","responsiveSuccessPayment":"d1yQmN","subtitle":"i6ErtQ","text":"OXMrzS","info":"NzBRxH","pending":"NWJy0y","close":"D2QcsE"};